<template>
  <div :class="['sidebar', { 'sidebar_mobile': isMobileDevice }]">
    <ul class="sidebar__menu">
      <li class="sidebar__menu__item">
        <router-link to="/statistics">
        <span class="icon icon-stat"></span>Статистика</router-link>
      </li>
      <li class="sidebar__menu__item">
        <router-link to="/advertising">
        <span class="icon icon-thumb"></span>Страница приветствия</router-link>
      </li>
      <li class="sidebar__menu__item">
        <router-link to="/redirect">
        <span class="icon icon-link"></span>Переадресация</router-link>
      </li>
      <li class="sidebar__menu__item">
        <router-link to="/unloading">
        <span class="icon icon-unloading"></span>Выгрузка</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
/**
 *  Компонент бокового меню.
 */

export default {
  name: 'Sidebar',
  mounted () {
    this.watchDeviceWidth()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sidebar.vue